import { openBlock, createBlock, Transition, withCtx, createElementVNode, normalizeClass, createElementBlock, normalizeStyle } from 'vue';
import { s as styleInject } from './style-inject.es-20d2f1f5.js';

// TODO: copied from keenUi
// replace it with orUi

var script = {
  name: 'UiProgressLinear',
  props: {
    type: {
      type: String,
      default: 'indeterminate' // 'determinate' or 'indeterminate'
    },

    color: {
      type: String,
      default: 'primary' // 'primary', 'accent', 'black' or 'white'
    },

    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    classes() {
      return [`ui-progress-linear--color-${this.color}`, `ui-progress-linear--type-${this.type}`];
    },
    moderatedProgress() {
      if (this.progress < 0) {
        return 0;
      }
      if (this.progress > 100) {
        return 100;
      }
      return this.progress;
    }
  }
};

const _hoisted_1 = ["aria-valuenow"];
const _hoisted_2 = {
  key: 1,
  class: "ui-progress-linear__progress-bar is-indeterminate",
  role: "progressbar",
  "aria-valuemax": 100,
  "aria-valuemin": 0
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: "ui-progress-linear--transition-fade"
  }, {
    default: withCtx(() => [createElementVNode("div", {
      class: normalizeClass(["ui-progress-linear", $options.classes]),
      "data-test": "service-navigation-loader"
    }, [$props.type === 'determinate' ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "ui-progress-linear__progress-bar is-determinate",
      role: "progressbar",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": $options.moderatedProgress,
      style: normalizeStyle({
        'transform': `scaleX(${$options.moderatedProgress / 100})`
      })
    }, null, 12 /* STYLE, PROPS */, _hoisted_1)) : (openBlock(), createElementBlock("div", _hoisted_2))], 2 /* CLASS */)]),

    _: 1 /* STABLE */
  });
}

var css_248z = ".ui-progress-linear {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 0.25rem;\n  overflow: hidden;\n  transition-timing-function: ease;\n  transition-duration: 0.3s;\n  transition-property: height, opacity;\n}\n.ui-progress-linear__progress-bar.is-determinate {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 0.25rem;\n  transition: transform 0.2s linear;\n  transform-origin: left;\n}\n.ui-progress-linear__progress-bar.is-indeterminate::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 0.25rem;\n  content: \"\";\n  background-color: inherit;\n  animation: ui-progress-linear-indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;\n}\n.ui-progress-linear__progress-bar.is-indeterminate::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 0.25rem;\n  content: \"\";\n  background-color: inherit;\n  animation: ui-progress-linear-indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;\n  animation-delay: 1.15s;\n}\n@keyframes ui-progress-linear-indeterminate {\n0% {\n    right: 100%;\n    left: -35%;\n}\n60% {\n    right: -90%;\n    left: 100%;\n}\n100% {\n    right: -90%;\n    left: 100%;\n}\n}\n@keyframes ui-progress-linear-indeterminate-short {\n0% {\n    right: 100%;\n    left: -200%;\n}\n60% {\n    right: -8%;\n    left: 107%;\n}\n100% {\n    right: -8%;\n    left: 107%;\n}\n}\n.ui-progress-linear--transition-fade-enter-active,\n.ui-progress-linear--transition-fade-leave-active {\n  transition: opacity 0.3s ease;\n}\n.ui-progress-linear--transition-fade-enter,\n.ui-progress-linear--transition-fade-leave-active {\n  opacity: 0;\n}\n.ui-progress-linear--color-primary {\n  background-color: rgba(33, 150, 243, 0.4);\n}\n.ui-progress-linear--color-primary .ui-progress-linear__progress-bar {\n  background-color: #2196f3;\n}\n.ui-progress-linear--color-accent {\n  background-color: rgba(213, 0, 249, 0.4);\n}\n.ui-progress-linear--color-accent .ui-progress-linear__progress-bar {\n  background-color: #d500f9;\n}\n.ui-progress-linear--color-black {\n  background-color: rgba(97, 97, 97, 0.4);\n}\n.ui-progress-linear--color-black .ui-progress-linear__progress-bar {\n  background-color: #616161;\n}\n.ui-progress-linear--color-white {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n.ui-progress-linear--color-white .ui-progress-linear__progress-bar {\n  background-color: white;\n}";
styleInject(css_248z);

script.render = render;
script.__file = "src/components/UiProgressLinear/UiProgressLinear.vue";

export { script as s };
